module.exports = __webpack_public_path__ + "static/img/hotline_bkg.b3912cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hotline_bkg.png
// module id = 0c58
// module chunks = 5